export default "__VITE_ASSET__DzEVSJoE__"